import EmblaCarousel from 'embla-carousel';

export const emblaReviews = () => {
    const emblaNode = document.querySelector('.reviews-embla');
    if (!emblaNode) return;

    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevButton = emblaNode.querySelector('.embla__prev')
    const nextButton = emblaNode.querySelector('.embla__next')

    if (!viewportNode) {
        return
    }

    const emblaApi = EmblaCarousel(viewportNode, {
        loop: true,
        align: 'start',
        slidesToScroll: 1
    })

    if (prevButton) {
        prevButton.addEventListener('click', () => {
            emblaApi.scrollPrev()
        })
    }

    if (nextButton) {
        nextButton.addEventListener('click', () => {
            emblaApi.scrollNext()
        })
    }
}
